import React from "react";

const AssetSummaryError = ({ className, message }) => {
  return (
    <div className={`no_finanacial_asset ${className}`}>
      <p>{message}</p>
    </div>
  );
};

export default AssetSummaryError;
